import { reactive, computed } from '@vue/composition-api';

export default function usePagination() {
  const pagination = reactive({
    perPageOptions: [5, 10, 25, 100],
    perPage: 10,
    currentPage: 1,
    rows: 0,
    totalRows: 0,
    totalPage: 10,
  });

  const onPageChange = (page) => {
    pagination.currentPage = page;
  };

  const onFilterEntity = (numOfEntity) => {
    pagination.perPage = numOfEntity;
  };

  const paginationInfo = computed(() => {
    const startItem = pagination.perPage * (pagination.currentPage - 1);

    return pagination.rows > 0
      ? `Showing ${startItem + 1} to ${startItem + pagination.rows} of ${
          pagination.totalRows
        } entries `
      : `Showing 0 to 0 of ${pagination.totalRows} entries `;
  });

  return { pagination, paginationInfo, onPageChange, onFilterEntity };
}
